
import { 
  LayoutDashboard, 
  Users, 
  CheckSquare, 
  Building, 
  Package,
  Megaphone
} from "lucide-react";
import type { MenuItem } from "../types";

export const mainSections: MenuItem[] = [
  {
    title: "الرئيسية",
    href: "/dashboard",
    icon: LayoutDashboard,
    color: "from-blue-500 to-blue-600",
    permission: "الرئيسية",
  },
  {
    title: "المهام",
    href: "/tasks",
    icon: CheckSquare,
    color: "from-orange-500 to-orange-600",
    permission: "المهام",
  },
  {
    title: "الموردين",
    href: "/suppliers",
    icon: Building,
    color: "from-cyan-500 to-cyan-600",
    permission: "الموردون",
  },
  {
    title: "الفنادق",
    href: "/hotels",
    icon: Building,
    color: "from-rose-500 to-rose-600",
    permission: "الفنادق",
  },
  {
    title: "حجز الفنادق (API)",
    href: "/hotel-booking",
    icon: Building,
    color: "from-amber-500 to-orange-600",
    permission: "الفنادق",
  },
  {
    title: "إنشاء باقة",
    href: "/create-package",
    icon: Package,
    color: "from-emerald-600 to-emerald-700",
    permission: "إنشاء الباقات",
  },
  {
    title: "الباقات السياحية",
    href: "/tourism-packages",
    icon: Package,
    color: "from-pink-500 to-pink-600",
    permission: "الباقات السياحية",
  },
  {
    title: "البحث عن الباقات",
    href: "/package-search",
    icon: Package,
    color: "from-purple-500 to-purple-600",
    permission: "البحث عن الباقات",
  },
  {
    title: "إدارة الإعلانات",
    href: "/admin-announcements",
    icon: Megaphone,
    color: "from-emerald-500 to-emerald-600",
    permission: "إدارة الإعلانات",
  },
];
